export default __webpack_public_path__ + "static/media/gymGuy.a0a0aa23.png";